import React, { useEffect, useState } from 'react';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from 'axios';
import { FONT_COLOR, BG_COLOR } from '../const/general'
import { postWithToken, deleteWithToken } from '../func/post_data_swr';
import { fetchWithUrl } from '../func/get_data_swr';
import { Box, Button, TextField,Table,  Select, MenuItem, FormControl, InputLabel,
  FormGroup, FormControlLabel, Checkbox, Radio, RadioGroup,TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Typography } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';


// 仮データ
const customers = [
  { code: 'C001', name: '顧客A', prefecture: '東京都' },
  { code: 'C002', name: '顧客B', prefecture: '大阪府' },
];

const municipalitiesByPref = {
  '東京都': ['新宿区', '渋谷区', '港区'],
  '大阪府': ['大阪市北区', '大阪市中央区'],
};

// バリデーションスキーマ
const validationSchema = Yup.object().shape({
  username: Yup.string().required('ユーザー名は必須です'),
  email: Yup.string().email('有効なメールアドレスを入力してください').required('メールアドレスは必須です'),
  // password: Yup.string().min(6, '6文字以上で入力してください').required('パスワードは必須です'),
  // customerCode: Yup.string().when('isAdmin', {
  //   is: true,
  //   then: (schema) => schema.required('顧客選択は必須です'),
  // }),
  // displayUnit: Yup.string().required('表示単位は必須です'),
});

export default function UserRegisterForm({ isAdmin = false }) {
  const [municipalities, setMunicipalities] = useState([]);

  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: '',
      password: '',
      email: 'dummy@prein.jp',
      enabled_prefs: '40',
      use_sac_flag: 0,
      dsbd_available_tabs: 'SummaryForCity',
      dsbd_default_cities: '',
      dsbd_default_unit: '4',
      isAdmin,
    },
    resolver: yupResolver(validationSchema),
  });

  const customerCode = watch('customerCode');

  useEffect(() => {
    const pref = customers.find((c) => c.code === customerCode)?.prefecture;
    const cityList = pref ? municipalitiesByPref[pref] || [] : [];
    setMunicipalities(cityList);
    setValue('selectedMunicipalities', []);
  }, [customerCode, setValue]);

  const handleMunicipalityChange = (name) => {
    const current = watch('selectedMunicipalities') || [];
    const updated = current.includes(name)
      ? current.filter((n) => n !== name)
      : [...current, name];
    setValue('selectedMunicipalities', updated);
  };

  // ユーザー一覧取得
  const fetchUsers = async () => {
    try {
      const res = await fetchWithUrl('api/get_user_list');
      console.log(res);
      console.log(res.users);
      setUsers(res.users);
    } catch (err) {
      console.error('ユーザー一覧取得失敗:', err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const onSubmit = async (data) => {
    try {
      const url = editingUser ? 'api/post_user_update' : 'api/post_user_register';
      await postWithToken(url, data);
      alert(editingUser ? '更新完了' : '登録完了');
      setEditingUser(null);
      fetchUsers();
    } catch (e) {
      console.error('登録/更新失敗', e);
      alert('登録/更新に失敗しました');
    }
  };

  // 編集ボタンクリック時
  const handleEdit = (user) => {
    setEditingUser(user);
    setValue('username', user.username);
    setValue('email', user.email);
    setValue('password', '');
    setValue('dsbd_default_cities', user.dsbd_default_cities);
  };

  const handleDelete = async () => {
    if (!editingUser) return;
    if (!window.confirm('このユーザーを削除しますか？')) return;
    try {
      await deleteWithToken(`api/delete_user/${editingUser.username}`);
      alert('削除が完了しました');
      fetchUsers();
      setEditingUser(null);
    } catch (err) {
      alert('削除に失敗しました');
    }
  };

  return (
    <>
      <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ maxWidth: 600, m: 'auto', p: 2, display: 'flex', flexDirection: 'column', gap: 2, backgroundColor: FONT_COLOR, color: BG_COLOR }}>
        <Controller
          name="username"
          control={control}
          render={({ field }) => (
            <TextField label="ユーザー名" {...field} error={!!errors.username} helperText={errors.username?.message} fullWidth />
          )}
        />

        <Controller
          name="password"
          control={control}
          render={({ field }) => (
            <TextField label="パスワード" type="password" {...field} error={!!errors.password} helperText={errors.password?.message} fullWidth />
          )}
        />
        
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <TextField label="メールアドレス" {...field} error={!!errors.email} helperText={errors.email?.message} fullWidth />
          )}
        />

        <Controller
          name="enabled_prefs"
          control={control}
          render={({ field }) => (
            <TextField label="都道府県リスト" {...field} error={!!errors.enabled_prefs} helperText={errors.enabled_prefs?.message} fullWidth />
          )}
        />

        <Controller
          name="use_sac_flag"
          control={control}
          render={({ field }) => (
            <TextField label="SACを利用するフラグ" {...field} error={!!errors.use_sac_flag} helperText={errors.use_sac_flag?.message} fullWidth />
          )}
        />

        <Controller
          name="dsbd_available_tabs"
          control={control}
          render={({ field }) => (
            <TextField label="ダッシュボードで利用するタブ" {...field} error={!!errors.dsbd_available_tabs} helperText={errors.dsbd_available_tabs?.message} fullWidth />
          )}
        />

        <Controller
          name="dsbd_default_cities"
          control={control}
          render={({ field }) => (
            <TextField label="ダッシュボードで初期選択する市町村" {...field} error={!!errors.dsbd_default_cities} helperText={errors.dsbd_default_cities?.message} fullWidth />
          )}
        />

        <Controller
          name="dsbd_default_unit"
          control={control}
          render={({ field }) => (
            <TextField label="ダッシュボードで初期表示する単位" {...field} error={!!errors.dsbd_default_unit} helperText={errors.dsbd_default_unit?.message} fullWidth />
          )}
        />

  {/* 
        {isAdmin && (
          <FormControl fullWidth error={!!errors.customerCode}>
            <InputLabel>顧客</InputLabel>
            <Controller
              name="customerCode"
              control={control}
              render={({ field }) => (
                <Select {...field} label="顧客">
                  {customers.map((c) => (
                    <MenuItem key={c.code} value={c.code}>{c.name}</MenuItem>
                  ))}
                </Select>
              )}
            />
            {errors.customerCode && <Typography color="error">{errors.customerCode.message}</Typography>}
          </FormControl>
        )}

        <FormControl component="fieldset">
          <Typography variant="subtitle1">ダッシュボード初期選択市町村</Typography>
          <FormGroup>
            {municipalities.map((name) => (
              <FormControlLabel
                key={name}
                control={
                  <Checkbox
                    checked={watch('selectedMunicipalities')?.includes(name)}
                    onChange={() => handleMunicipalityChange(name)}
                  />
                }
                label={name}
              />
            ))}
          </FormGroup>
        </FormControl>

        <FormControl component="fieldset" error={!!errors.displayUnit}>
          <Typography variant="subtitle1">ダッシュボード表示単位</Typography>
          <Controller
            name="displayUnit"
            control={control}
            render={({ field }) => (
              <RadioGroup row {...field}>
                <FormControlLabel value="市町村" control={<Radio />} label="市町村" />
                <FormControlLabel value="字" control={<Radio />} label="字" />
                <FormControlLabel value="メッシュ" control={<Radio />} label="メッシュ" />
              </RadioGroup>
            )}
          />
          {errors.displayUnit && <Typography color="error">{errors.displayUnit.message}</Typography>}
        </FormControl> */}
        <Button type="submit" variant="contained" color="primary">
          {editingUser ? '更新' : '登録'}
        </Button>
        {editingUser && (
          <Button onClick={handleDelete} variant="outlined" color="error">
            削除
          </Button>
        )}
      </Box>

      {/* 一覧表示 */}
      <Box sx={{ mx: 'auto', mt: 4 }}>
        <Typography variant="h6" gutterBottom>ユーザー一覧</Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ユーザー名</TableCell>
                <TableCell>メール</TableCell>
                <TableCell>都道府県</TableCell>
                <TableCell>ダッシュボード初期選択市町村</TableCell>
                <TableCell>ダッシュボード表示ページ</TableCell>
                <TableCell>ダッシュボード表示単位</TableCell>
                <TableCell align="right">操作</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((u) => (
                <TableRow key={u.username}>
                  <TableCell>{u.username}</TableCell>
                  <TableCell>{u.email}</TableCell>
                  <TableCell>{u.enabled_prefs}</TableCell>
                  <TableCell>{u.dsbd_default_cities}</TableCell>
                  <TableCell>{u.dsbd_available_tabs}</TableCell>
                  <TableCell>{u.dsbd_default_unit}</TableCell>
                  <TableCell align="right">
                  <IconButton onClick={() => handleEdit(u)}><Edit /></IconButton>
                  <IconButton onClick={() => {
                    setEditingUser(u);
                    handleDelete();
                  }}><Delete /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}
